---
title: "นโยบายความเป็นส่วนตัว"
path: "/th/นโยบายความเป็นส่วนตัว"
seoTitle: "นโยบายความเป็นส่วนตัว | Dutch Passion ประเทศไทย"
seoDescription: "Dutch Passion Thailand เก็บ ใช้ และปกป้องข้อมูลส่วนบุคคลของคุณอย่างไร เมื่อคุณเข้าชมเว็บไซต์หรือสั่งซื้อเมล็ดพันธุ์กัญชาจากเรา"
---

> ฉบับภาษาไทยนี้เขียนขึ้นสำหรับผู้ใช้ในประเทศไทยโดยเฉพาะ หากมีข้อความใดขัดแย้งกัน
> ให้ยึด[นโยบายความเป็นส่วนตัวฉบับภาษาอังกฤษ](/privacy-policy) เป็นหลัก

นโยบายนี้อธิบายว่า Dutch Passion Thailand เก็บรวบรวม ใช้ เปิดเผย และเก็บรักษาข้อมูลส่วนบุคคล
ของคุณอย่างไร เมื่อคุณเข้าชม dutchpassion.co.th หรือสั่งซื้อสินค้าจากเรา เราดำเนินการตาม
พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)

## ข้อมูลที่เราเก็บ

**ข้อมูลที่คุณให้กับเราโดยตรง**

- **เมื่อคุณสั่งซื้อ** — ชื่อ นามสกุล อีเมล เบอร์โทรศัพท์ และที่อยู่สำหรับจัดส่ง รวมถึง
  หมายเหตุที่คุณเขียนแนบมากับคำสั่งซื้อ
- **เมื่อคุณติดต่อเรา** — ชื่อ อีเมล หัวข้อ และเนื้อหาข้อความของคุณ

**ข้อมูลที่เก็บโดยอัตโนมัติ**

- ข้อมูลการใช้งานเว็บไซต์แบบไม่ระบุตัวตนผ่าน Google Analytics ได้แก่ หน้าที่เข้าชม
  ประเภทอุปกรณ์ และแหล่งที่มาโดยประมาณ
- หมายเลข IP ของคุณ ใช้ชั่วคราวเพื่อจำกัดจำนวนการส่งแบบฟอร์มติดต่อและป้องกันการใช้งานในทางที่ผิด

**ข้อมูลการชำระเงินที่เราไม่ได้เก็บ**

รายละเอียดบัตรเครดิตและเดบิตถูกส่งจากเบราว์เซอร์ของคุณไปยัง Omise ผู้ให้บริการชำระเงินของเรา
โดยตรง ข้อมูลบัตรไม่เคยผ่านเว็บไซต์นี้และเราไม่ได้จัดเก็บไว้ ดู
[นโยบายของ Omise](https://www.omise.co/terms/thailand)

## เหตุใดเราจึงใช้ข้อมูลนี้

- เพื่อดำเนินการตามคำสั่งซื้อ จัดส่งสินค้า และติดต่อคุณเกี่ยวกับคำสั่งซื้อนั้น
- เพื่อตอบคำถามที่คุณส่งมาผ่านแบบฟอร์มติดต่อหรืออีเมล
- เพื่อป้องกันการใช้งานในทางที่ผิดและรักษาความปลอดภัยของเว็บไซต์
- เพื่อทำความเข้าใจว่าเว็บไซต์ถูกใช้งานอย่างไร และปรับปรุงให้ดีขึ้น

เราไม่ขายข้อมูลส่วนบุคคลของคุณ และไม่ส่งอีเมลการตลาดเว้นแต่คุณจะขอ

## เราเปิดเผยข้อมูลกับใครบ้าง

เฉพาะกับผู้ให้บริการที่จำเป็นต่อการดำเนินงานของร้าน ได้แก่ Omise สำหรับการชำระเงิน
Mailgun สำหรับการส่งอีเมลจากแบบฟอร์มติดต่อ Cloudflare สำหรับการให้บริการเว็บไซต์และ
ป้องกันการใช้งานในทางที่ผิด Google Analytics สำหรับสถิติการใช้งาน และบริษัทขนส่งที่นำ
พัสดุไปส่งให้คุณ แต่ละรายได้รับเฉพาะข้อมูลเท่าที่จำเป็นต่อหน้าที่ของตน

เว็บไซต์ของเรามีผู้ช่วยตอบคำถามอัตโนมัติ (AI) ข้อความที่คุณพิมพ์ในกล่องแชทและคำตอบในบทสนทนานั้น
จะถูกส่งไปยัง DeepSeek (Hangzhou DeepSeek Artificial Intelligence Co., Ltd.) ผ่าน API
ซึ่งประมวลผลบนเซิร์ฟเวอร์ในประเทศจีนเพื่อสร้างคำตอบ ถือเป็นการส่งข้อมูลออกนอกราชอาณาจักร
เราไม่ได้จัดเก็บบทสนทนาไว้เอง และไม่ได้ขอข้อมูลส่วนบุคคลในกล่องแชท จึงขอแนะนำว่าอย่าพิมพ์ข้อมูล
ที่คุณไม่ต้องการให้ประมวลผลในลักษณะนี้ ดูรายละเอียดได้ที่
[นโยบายความเป็นส่วนตัวของ DeepSeek](https://cdn.deepseek.com/policies/en-US/deepseek-privacy-policy.html)

แบบฟอร์มติดต่อและกล่องแชทของเราได้รับการป้องกันด้วย Cloudflare Turnstile ซึ่งเป็นบริการตรวจจับบอท
เมื่อคุณใช้งานฟีเจอร์เหล่านี้ Turnstile จะเก็บข้อมูลจากเบราว์เซอร์ของคุณ เช่น หมายเลข IP
ลักษณะของเบราว์เซอร์และอุปกรณ์ และรูปแบบการโต้ตอบ รวมถึงอาจตั้งคุกกี้ เพื่อยืนยันว่าคุณเป็นผู้ใช้จริง
ไม่ใช่สคริปต์อัตโนมัติ เราใช้ข้อมูลนี้เพื่อป้องกันสแปมและการใช้งานในทางที่ผิดเท่านั้น ดูรายละเอียดได้ที่
[นโยบายความเป็นส่วนตัวของ Cloudflare Turnstile](https://www.cloudflare.com/en-gb/turnstile-privacy-policy/)

เราอาจเปิดเผยข้อมูลเมื่อกฎหมายกำหนด

## เราเก็บข้อมูลไว้นานเท่าใด

ข้อมูลคำสั่งซื้อถูกเก็บไว้ตามระยะเวลาที่กฎหมายบัญชีและภาษีกำหนด ข้อความจากแบบฟอร์มติดต่อ
ถูกเก็บไว้เท่าที่จำเป็นในการตอบกลับและติดตามผล ตัวนับการจำกัดอัตราการส่งจะหมดอายุภายในหนึ่งชั่วโมง

## สิทธิของคุณ

ภายใต้ PDPA คุณมีสิทธิขอเข้าถึงข้อมูลส่วนบุคคลของคุณ ขอให้แก้ไขข้อมูลที่ไม่ถูกต้อง
ขอให้ลบข้อมูล ขอให้ระงับการใช้ คัดค้านการประมวลผล ขอรับสำเนาข้อมูลในรูปแบบที่อ่านได้ด้วยเครื่อง
และถอนความยินยอมที่เคยให้ไว้

หากต้องการใช้สิทธิใด ๆ ข้างต้น กรุณาติดต่อ info@dutchpassion.co.th เราจะตอบกลับภายใน
ระยะเวลาที่กฎหมายกำหนด หากคุณเห็นว่าเราจัดการข้อมูลของคุณไม่ถูกต้อง คุณมีสิทธิร้องเรียน
ต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล

## คุกกี้

เราใช้คุกกี้ที่จำเป็นต่อการทำงานของตะกร้าสินค้าและการชำระเงิน และคุกกี้เชิงวิเคราะห์จาก
Google Analytics คุณสามารถบล็อกคุกกี้ได้ในเบราว์เซอร์ของคุณ แต่ตะกร้าสินค้าจะไม่ทำงาน
หากปิดคุกกี้ที่จำเป็น นอกจากนี้ Cloudflare Turnstile
อาจตั้งคุกกี้เพื่อแยกผู้ใช้จริงออกจากสคริปต์อัตโนมัติ ดู
[นโยบายความเป็นส่วนตัวของ Cloudflare Turnstile](https://www.cloudflare.com/en-gb/turnstile-privacy-policy/)

## การเปลี่ยนแปลงนโยบายนี้

หากเราแก้ไขนโยบายนี้ เราจะปรับปรุงหน้านี้ การเปลี่ยนแปลงมีผลตั้งแต่วันที่เผยแพร่

## ติดต่อเรา

คำถามเกี่ยวกับนโยบายนี้หรือข้อมูลของคุณ กรุณาส่งอีเมลถึง info@dutchpassion.co.th
